import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

/**
 * Virtual pages service
 */
@Injectable({
  providedIn: 'root'
})
export class VirtualPagesService {

  /**
   * holder for virtual pages data per widget type (key is WIDGET_MASTER_SLAVE_MSG)
   */
  protected virtualPagesDataMap = new Map<string, Array<any>>();

  /**
   * Sets the pages data
   * @param key
   * @param pagesData
   */
  setPagesData(key: string, pagesData: Array<any>) {
    this.virtualPagesDataMap.set(key, pagesData);
  }

  /**
   * Gets the pages data
   * @param key
   * @param pageIndex
   * @returns
   */

  getPageData(key: string, pageIndex: number) {
    const widgetPagesData = this.virtualPagesDataMap.get(key);
    let slavePageData;
    if (widgetPagesData[pageIndex]) {
      !environment.production && console.log(`Returning slave page ${pageIndex} from page data cache`);
      slavePageData = widgetPagesData[pageIndex];
      widgetPagesData[pageIndex] = null;//reset it to prevent multiple answers
    }

    return slavePageData;
  }
}
